import { createAction, props } from '@ngrx/store';
import { IAppState } from './IAppState';
import { ILocationsData } from '@services';

export const updateStore = createAction('UPDATE_STORE', props<{state: IAppState}>());
export const updateLocations = createAction('UPDATE_LOCATIONS', props<{locations: ILocationsData}>());
export const updateUserLocations = createAction('UPDATE_USER_LOCATIONS', props<{locations: number[]}>());
export const resetStore = createAction('RESET_STORE');
